module.exports = __webpack_public_path__ + "media/images/favicons/60x60-ebad6e0eefdfe68aa142ecbc1fa8dbb4.png";